import * as yup from "yup";

const emptyStringToUndefined = (value, originalValue) =>
  originalValue === "" ? undefined : value;

export const schema = yup
  .object({
    board_name: yup
      .string()
      .trim()
      .required("Board name is required"),
    workflow_id: yup
      .number()
      .transform(emptyStringToUndefined)
      .typeError("Board Workflow is required")
      .positive()
      .integer()
      .required("Board Workflow is required"),
    owner_user_id: yup
      .number()
      .transform(emptyStringToUndefined)
      .typeError("Board owner is required")
      .required("Board owner is required"),
    is_private: yup.string().required("Access is required"),
  })
  .required();
